// Module
var code = `<pick-a-date show-errors block="block" ng-model="answer.value" ng-model-options="{ debounce: 1000 }" ng-required="block.required" picker-disabled="false" picker-min-date="block.content.range.min" picker-max-date="block.content.range.max" picker-labelled-by="block-label-{{block.id}}" uib-tooltip="{{
    'Selecting an answer displays it as preselected on the registration form.'
      | translate
  }}" tooltip-enable="{{ isAdmin }}"> </pick-a-date> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/blocks/dateQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;